import { useAuth } from '../contexts/AuthContext';

export const useNivelAcesso = () => {
  const { 
    user, 
    hasNivelAcesso, 
    isAdmin, 
    isGerente, 
    isOperador, 
    isUsuario, 
    isVisualizador,
    getNivelUsuario,
    podeGerenciarNivel 
  } = useAuth();

  const getNivelLabel = (nivel) => {
    const labels = {
      admin: 'Administrador',
      gerente: 'Gerente',
      operador: 'Operador',
      usuario: 'Usuário',
      visualizador: 'Visualizador'
    };
    return labels[nivel] || nivel;
  };

  const getNivelBadgeColor = (nivel, darkMode = false) => {
    const colors = darkMode ? {
      admin: 'bg-red-900/20 text-red-400',
      gerente: 'bg-blue-900/20 text-blue-400',
      operador: 'bg-green-900/20 text-green-400',
      usuario: 'bg-yellow-900/20 text-yellow-400',
      visualizador: 'bg-gray-700 text-gray-300'
    } : {
      admin: 'bg-red-100 text-red-800',
      gerente: 'bg-blue-100 text-blue-800',
      operador: 'bg-green-100 text-green-800',
      usuario: 'bg-yellow-100 text-yellow-800',
      visualizador: 'bg-gray-100 text-gray-800'
    };
    return colors[nivel] || (darkMode ? 'bg-gray-700 text-gray-300' : 'bg-gray-100 text-gray-800');
  };

  const getNiveisDisponiveis = () => {
    const todosNiveis = [
      { value: 'admin', label: 'Administrador' },
      { value: 'gerente', label: 'Gerente' },
      { value: 'operador', label: 'Operador' },
      { value: 'usuario', label: 'Usuário' },
      { value: 'visualizador', label: 'Visualizador' }
    ];

    // Filtrar apenas níveis que o usuário pode gerenciar
    return todosNiveis.filter(nivel => podeGerenciarNivel(nivel.value));
  };

  const podeEditarUsuario = (usuarioAlvo) => {
    if (!usuarioAlvo?.nivel_acesso) return false;
    return podeGerenciarNivel(usuarioAlvo.nivel_acesso);
  };

  const podeCriarUsuario = (nivelAlvo) => {
    return podeGerenciarNivel(nivelAlvo);
  };

  return {
    user,
    hasNivelAcesso,
    isAdmin,
    isGerente,
    isOperador,
    isUsuario,
    isVisualizador,
    getNivelUsuario,
    podeGerenciarNivel,
    getNivelLabel,
    getNivelBadgeColor,
    getNiveisDisponiveis,
    podeEditarUsuario,
    podeCriarUsuario
  };
};

export default useNivelAcesso;